import {Injectable, PLATFORM_ID, TransferState, inject, makeStateKey, signal} from '@angular/core';
import {isPlatformServer} from '@angular/common';

const UNAVAILABLE = makeStateKey<boolean>('api-unavailable');

/**
 * «API не ответил при серверном рендере» (#1174): SSR ставит флаг, страница показывает плашку
 * «перегрузка, обновите через минуту». Флаг уходит в браузер через TransferState — иначе после
 * гидрации плашка исчезла бы, а Angular увидел бы расхождение серверного и клиентского HTML.
 */
@Injectable({providedIn: 'root'})
export class ApiAvailabilityService {
  private readonly state = inject(TransferState);
  private readonly server = isPlatformServer(inject(PLATFORM_ID));

  readonly unavailable = signal(this.state.get(UNAVAILABLE, false));

  markUnavailable(): void {
    this.unavailable.set(true);
    if (this.server) {
      this.state.set(UNAVAILABLE, true);
    }
  }
}
